import { PuzzleAccount, useDisconnect } from '@puzzlehq/sdk';
import { useNavigate } from '@tanstack/react-router';
import { shortenAddress } from 'jigsaw';
import { BiWalletAlt } from 'react-icons/bi';
import { Route as index_route } from '@src/routes/index.js';
import {
  HStack,
  Text,
  Dialog,
  DialogTrigger,
  DialogContent,
  VStack,
  DialogHeader,
  DialogTitle,
  DialogOverlay,
  DialogClose,
  DialogFooter,
  Button,
} from 'ui_2';

export const SelectedAccount = ({ account }: { account: PuzzleAccount }) => {
  const { disconnect, loading } = useDisconnect();
  const navigate = useNavigate();

  return (
    <Dialog>
      <DialogOverlay className='bg-gray-900' />
      <DialogTrigger asChild>
        <HStack className='h-fit cursor-pointer items-center gap-4 rounded-full border border-gray-100 bg-gray-50 px-4 py-2 transition-colors hover:bg-white active:bg-gray-200'>
          <BiWalletAlt size={20} />
          <Text font='md'>{shortenAddress(account.address)}</Text>
        </HStack>
      </DialogTrigger>
      <DialogContent
        aria-describedby='account-description'
        className='w-4/5 max-w-[325px] bg-gray-50'
        style={{ borderRadius: 30 }}
        showOverlay={false}
      >
        <DialogHeader>
          <DialogTitle className='text-center'>
            <Text color='black' font='medium-sm' id='account-description'>
              Profile
            </Text>
          </DialogTitle>
          <DialogClose />
        </DialogHeader>
        <VStack>
          <Text font='sm' color='black'>
            Address
          </Text>
          <div className='w-full text-left' style={{ wordBreak: 'break-word' }}>
            <Text color='black'>{account.address}</Text>
          </div>
        </VStack>
        <DialogFooter className='w-full'>
          <HStack className='w-full justify-center px-4'>
            <Button
              variant='gray'
              className='border border-[#B6B6B6] bg-gray-200'
              disabled={loading}
              onClick={() => {
                void disconnect();
                void navigate({ to: index_route.to });
              }}
            >
              Disconnect
            </Button>
          </HStack>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
